
import {
    FETCH_LAWYER_CONTRACTS
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case FETCH_LAWYER_CONTRACTS:
        return action.payload
      default:
        return state
    }
  }
